import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  display: flex;

  flex: 1;

  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`
export const ContainerText = styled.div`
  width: 100%;
  max-width: 513px;

  display: flex;
  flex-direction: column;

  padding: 0 25px;
`

export const StyledError = styled.p`
  width: 100%;
  color: red;
  padding-top: 10px;
  font-weight: 400;
  font-size: 12px;
`
